import React from 'react'
import styled, { useTheme } from 'styled-components'
import { getTheme } from 'Shared/theme'
import propTypes from 'prop-types'

const Headers = ({ headers, themeColor }) => {
  const theme = useTheme()

  return (
    <TopBarDocumentLinkUL className="me-3">
      {headers.map((header, index) => (
        <TopBarDocumentLinkLI key={index} color={header.color} $themeColor={themeColor || getTheme(theme.id).primary}>
          <TopBarDocumentLink color={header.color} href={header.path} target="_blank">
            {header.title}
          </TopBarDocumentLink>
        </TopBarDocumentLinkLI>
      ))}
    </TopBarDocumentLinkUL>
  )
}

const TopBarDocumentLinkUL = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  height: 100%;
  @media (max-width: 992px) {
    display: none;
  }
`

const TopBarDocumentLink = styled.a`
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none !important;
  color: ${props => props.theme.textGreyTintedDarker};
  opacity: 0.95;
  height: 100%;
  display: flex;
  align-items: center;
`

const TopBarDocumentLinkLI = styled.li`
  display: flex;
  height: 100%;
  align-items: center;
  margin: 0 16px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  &:hover ${TopBarDocumentLink} {
    color: ${({ $themeColor }) => $themeColor};
    opacity: 1;
  }
`

Headers.propTypes = {
  headers: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string,
      path: propTypes.string,
      position: propTypes.number,
      color: propTypes.string
    })
  ),
  themeColor: propTypes.string
}

export default Headers
